import { DebitAccount } from '@generated-types';

export const debitAccountMock1: DebitAccount = {
    id: 'MjM1MTEzMDM0xIJfMDk4MTc2OTbEjjk=',
    externalId: undefined,
    bankRegistrationNumber: '2351',
    number: '23511303451',
    owner: '09817696179',
    currency: 'NOK',
    availableBalance: 0.0,
    bookedBalance: 0.0,
    creditLine: 0.0,
    blockedAmount: 0.0,
    totalReservedAmount: 0.0,
    productId: '100101',
    productName: 'Brukskonto',
    agreementName: 'INCIE, WINCIE',
    allowedOperations: {
        orderCard: true,
        accessTransactions: false,
        setCardPin: true,
    },
};
